import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { PRICE_SCHEDULE_MODES } from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import {
  ROUTE_PATHS,
  LEGACY_SCREEN_VIEW,
  LOCAL_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";

import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./ClientPatientPayScheduleFormConfig";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import { LegacyResolvers } from "../../common_nextgen/utils/UtilFunctions";

const screenInfo = {
  ADD: ["Add Client Patient Pay Schedule", "RCPS6003"],
  CHANGE: ["Client Patient Pay Schedule Detail", "RCPS6004"],
  VIEW: ["Client Patient Pay Schedule Detail", "RCPS6004"],
};

const ClientPatientPayScheduleForm = ({ mode }) => {
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();

  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    selectedSchedules = [],
    selectedPatients = [],
    previousScreen = ROUTE_PATHS.CLIENT_PATIENT_PAY_SCHEDULE,
    currentIndex: initialIndex = 0,
    paramsData,
    lookupMode: initialLookupMode = false,
    lookupScreen,
    lookupParams,
    navigateData,
    formData: baseFormData = {},
  } = currentState;
  console.log("current state", currentState);

  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [lookupMode, setLookupMode] = useState(initialLookupMode);
  const toast = useToast();

  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});

  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const resetLookupMode = () => {
    setLookupMode(false);
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(
      lookupScreen,
      { params },
      handleReceiveData,
      formData,
      false,
      handleNavigate,
      resetLookupMode
    );
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    const { default: viewParams } = fieldMapping;
    if (viewType === "legacy") {
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      //showModal(lookupScreen, { params }, null, formData, true);
      // const { default: screenNumber } = lookupScreen;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["target"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      console.log("param data", paramData);
      const navigationPath = ROUTE_PATHS[LOCAL_SCREEN_VIEW[screenNumber]];
      navigateToPage(navigationPath, [
        ...previousState,
        { ...currentState, currentIndex, formData: formData },
        {
          selectedPatients: [paramData],
          currentIndex: 0,
          paramsData: { ...paramData, cscStepNbr: null },
          previousScreen: location.pathname,
        },
      ]);
    }
  };

  const handleNavigate = (data, screenNumber, params, formData) => {
    console.log(data);
    if (data?.navType === "local") {
      navigateToPage(data.target, [
        ...previousState,
        {
          ...currentState,
          currentIndex,
          lookupMode: true,
          lookupScreen: screenNumber,
          lookupParams: params,
          navigateData: data.data,
          formData: formData,
        },
        {
          selectedPatients: [data.data],
          previousScreen: location.pathname,
          paramsData: data.data,
          currentIndex: 0,
        },
      ]);
    }
  };

  useEffect(() => {
    if (lookupMode && initialFormData && Object.keys(initialFormData).length) {
      //console.log("lookup auto init", initialFormData, navigateData);
      //const lookupParamsData =
      console.log("navigate data", lookupParams, navigateData);
      //navigateData;
      const params = lookupParams.fieldMapping.default;
      const paramData = params?.reduce((acc, key) => {
        if (navigateData.hasOwnProperty(key["target"])) {
          acc[key["source"]] = navigateData[key["target"]];
        }
        return acc;
      }, {});
      showModal(
        lookupScreen,
        { params: lookupParams },
        handleReceiveData,
        { ...initialFormData, ...paramData },
        null,
        handleNavigate,
        resetLookupMode
      );
    }
  }, [initialFormData, lookupMode, lookupParams, lookupScreen]);

  const handleBack = () => {
    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setInitialFormData({});
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>-</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/ps6RebillPatientPaySch";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/ps6RebillPatientPaySch";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];
    }

    if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {
      infoChanged = false;
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                                          toast.current.show({
                                            severity: "info",
                                            summary: "",
                                            detail: responseStatus.message,
                                            life: 3000,
                                          });
                                        } else {
                                          toast.current.show({
                                            severity: "success",
                                            summary: "",
                                            detail: responseStatus.message,
                                            life: 3000,
                                          }); 
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      }
    } }catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);
  useEffect(() => {
    setLookupMode(initialLookupMode);
  }, [initialLookupMode]);

  useEffect(() => {
    const fetchInitialData = async () => {
      let url = isAddMode(currentMode)
        ? `api/ps6RebillPatientPaySch/initial-form-data/${encodeURIComponent(
            selectedPatients[currentIndex].ps3PatientPaySchName
          )}`
        : `api/ps6RebillPatientPaySch/${encodeURIComponent(
            currentState.selectedSchedules[currentIndex].ps3PatientPaySchName
          )}?ps6SeqNbr=${
            currentState.selectedSchedules[currentIndex].ps6SeqNbr
          }`;
      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };

    if (!Object.keys(initialFormData).length) {
      fetchInitialData();
    }
  }, [mode, currentIndex, initialFormData]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default ClientPatientPayScheduleForm;
